/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as contractsDetailsSlice from './contractsDetailsSlice';

export default function* watchContractsDetailsSaga() {
	yield takeLatest(
		contractsDetailsSlice.getTableStart.type,
		commonSagas.getTable,
	);
	yield takeLatest(
		contractsDetailsSlice.getItemStart.type,
		commonSagas.getItem,
	);
	yield takeLatest(
		contractsDetailsSlice.createItemStart.type,
		commonSagas.createItem,
	);
	yield takeLatest(
		contractsDetailsSlice.updateItemStart.type,
		commonSagas.updateItem,
	);
	yield takeLatest(
		contractsDetailsSlice.deleteItemsStart.type,
		commonSagas.deleteItems,
	);
	yield takeLatest(
		contractsDetailsSlice.deleteItemStart.type,
		commonSagas.deleteItem,
	);
	yield takeLatest(
		contractsDetailsSlice.getTableStructureStart.type,
		commonSagas.getTableStructure,
	);
	yield takeLatest(
		contractsDetailsSlice.getItemDocumentsStart.type,
		commonSagas.getItemDocuments,
	);
	yield takeLatest(
		contractsDetailsSlice.uploadItemDocumentsStart.type,
		commonSagas.uploadItemDocuments,
	);
	yield takeLatest(
		contractsDetailsSlice.deleteItemDocumentStart.type,
		commonSagas.deleteItemDocument,
	);
	yield takeLatest(
		contractsDetailsSlice.getTableExcelStart.type,
		commonSagas.getTableExcel,
	);
}
